<template>
    <DataTable :value="datos" :row-style-class="getRowStyle">
    <Column field="codigo" :header="$t('general.codigo')"></Column>
    <Column field="concepto" :header="$t('general.concepto')"></Column>
    <Column field="descuento" :header="$t('general.descuento')"></Column>
    <Column field="cantidad" :header="$t('general.cantidad')"></Column>
    <Column field="precio" :header="$t('general.precio')"></Column>
    <Column field="importe" :header="$t('general.importe')"></Column>
    </DataTable>
</template>
<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
export default {
    props: ['id', 'servicio', 'tipodefactura', 'ffac','destinatario','asegurado'],
    components: {
        DataTable,
        Column 
    },
    data() {
        return {
            datos: [ ],
            siguientenumero:'',
        }
    },
    methods: {
        getRow(rowData) {
            // Retorna el elemento de fila que se debe arrastrar
            // Puedes ajustar esto según la estructura de tus datos y fila
            return rowData;
        },
        
        async cargardatos() {
            console.log('trab', this.$props.destinatario[1].trabajos);
                //POST  modulos/pwgsapi/index.php/facturas/:id_servicio/previo-facturacion
            var codigo = '';
            var concepto = '';
            var precio = '';
            var cantidad = '';
            var importe = '';
            var descuento = '';
            var i = 0;

                i = 0;
                this.datos = [];
            for (var trabajo in this.$props.destinatario[1].trabajos)  {
                codigo = this.$props.destinatario[1].trabajos[trabajo].codigo;
                concepto = this.$props.destinatario[1].trabajos[trabajo].nombre;
                //try { concepto = decodeURIComponent(this.$props.destinatario[1].trabajos[trabajo].nombre) } catch (e) { console.log(e); concepto = this.$props.destinatario[1].trabajos[trabajo].nombre }
                precio = this.$props.destinatario[1].trabajos[trabajo].total_trabajo;
                cantidad = this.$props.destinatario[1].trabajos[trabajo].cantidad;
                importe = parseFloat(this.$props.destinatario[1].trabajos[trabajo].total).toFixed(2);           
                descuento =  (cantidad*precio-importe).toFixed(2);
                this.datos[i] = { codigo, concepto, precio, cantidad, importe, descuento };
                
                i++;             
           }   
        }
    },
    mounted() {
        this.cargardatos();
    },
    watch: {
        id() {
            this.cargardatos();
        },
        ffac() { 
            this.cargardatos();
        },
         


    }
}
</script>